import { GridItem, Grid, Checkbox,FormLabel, Button, Card, CardBody, Heading, VStack, Text, 

    InputGroup,InputLeftAddon,Stack,IconButton,Image ,

     HStack, 
     CardHeader, CardFooter } from "@chakra-ui/react"
import "./notestyle.css"
import { useEffect, useRef, useState } from "react"


import {FaTimes, FaCheck } from "react-icons/fa";

import { useDispatch, useSelector } from "react-redux";
import { deleteNotes, updateNotes } from "../../../redux/notes/note_actions"
import { getDestinos} from "../../../redux/destinos/destino_actions";
import { getEstados} from "../../../redux/estados/estado_actions";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Input,Select ,
    Textarea,
    useDisclosure
} from "@chakra-ui/react";

import { Flex, Tag, Segmented } from 'antd';

export default function NoteCard({title, documento, telefono, correoelectronico, referencia, estado, destino, body, pagado , color, user, id}){
    
    const dispatch = useDispatch()
    

    const {loadingdestino, errordestino, datadestino} = useSelector((state)=>state.destinoReducer)
    const {loadingestado, errorestado, dataestado} = useSelector((state)=>state.estadoReducer)


    const { isOpen, onOpen, onClose } = useDisclosure()
    const initialRef = useRef(null)
    const finalRef = useRef(null)
    // const [notes, setNotes] = useState([])
    const [tempTitle, setTitle] = useState(title)
    const [tempDocumento, setDocumento] = useState(documento)
    const [tempTelefono, setTelefono] = useState(telefono)
    const [tempCorreoElectronico, setCorreoElectronico] = useState(correoelectronico)
    const [tempReferencia, setReferencia] = useState(referencia)
    const [tempEstado, setEstado] = useState(estado)
    const [tempDestino, setDestino] = useState(destino)
    const [tempBody, setBody] = useState(body)
    const [tempPagado,setPagado] = useState(pagado);
    const [tempID,setId] = useState();  
    const updateNote = ()=>{
        dispatch(updateNotes(id, {title: tempTitle, 
                                   documento:tempDocumento, 
                                   telefono: tempTelefono, 
                                   correoelectronico: tempCorreoElectronico, 
                                   referencia: tempReferencia, 
                                   estado: tempEstado, destino: tempDestino, pagado: tempPagado, body: tempBody}))
        onClose()
    }

    useEffect(()=>{              
        // dispatch(getDestinos());        
        // dispatch(getEstados());  
    },[])



    return <Card background={color} className="card" align={"center"} size='md'>

        
        <CardBody mt={"10px"} height = {"50%"}>                                                                 

            <Text fontSize='1xl'>{destino}</Text> 
            <Text fontSize='2xl'>{title}</Text> 
            
            <Text fontSize='1xl'>{documento}</Text> 
            <Text fontSize='1xl'>{telefono}</Text> 
            <Text fontSize='1xl'>{correoelectronico}</Text> 
            <Text fontSize='1xl'>{referencia}</Text> 
            <Text fontSize='1xl'>{pagado}</Text> 
            <Text fontSize='3xl'>{estado}</Text>                         
            {/* <Text fontSize='1xl'>{id}</Text>  */}

            {/* title, documento, telefono, correoelectronico, referencia, estado, destino, body, pagado */}


            <Text noOfLines={"8"}>{body}</Text>                     
        </CardBody>
        <CardFooter height={"30%"}>
            <HStack width = {"100%"}>
                <>
                <Button bgColor={"#00e9bf"} 
                        // onClick={onOpen}
                        onClick={() => {
                            setId(id);
                            setTitle(title);
                            setDocumento(documento);
                            setTelefono(telefono);
                            setCorreoElectronico(correoelectronico);
                            setReferencia(referencia);
                            setEstado(estado);
                            setDestino(destino);
                            setBody(body);
                            setPagado(pagado);
                            onOpen();
                      }}
                >Editar</Button>
                    <Modal
                    initialFocusRef={initialRef}
                    finalFocusRef={finalRef}
                    isOpen={isOpen}
                    onClose={onClose}
                    >
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>Editar Nota</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody pb={6}>

                        <Stack spacing={4}>
                            <InputGroup>
                                <InputLeftAddon width={150}>ID</InputLeftAddon>
                                <Input isDisabled value={id} onChange={(e)=>setId(e.target.value)}></Input>
                            </InputGroup>

                            <InputGroup>
                                <InputLeftAddon width={150}>Destino</InputLeftAddon>
                                <Select placeholder='Selecciona Opción' onChange={(e)=>setDestino(e.target.value)}
                                        defaultValue={tempDestino}>
                                            { datadestino?.map(c => (<option key={c.descripcion} value={c.descripcion}>{c.descripcion}</option>))}
                                </Select>                          
                            </InputGroup>                                                                              

                            <InputGroup>
                                <InputLeftAddon width={150}>Nombre</InputLeftAddon>
                                <Input value={tempTitle} name="nombre" placeholder="Introduce el nombre" onChange={(e)=>setTitle(e.target.value)}></Input>
                            </InputGroup>

                            <InputGroup>
                                <InputLeftAddon width={150}>Documento</InputLeftAddon>
                                <Input value={tempDocumento} name="documento" placeholder="Introduce el nº documento" onChange={(e)=>setDocumento(e.target.value)}></Input>                            
                            </InputGroup>

                            <InputGroup>
                                <InputLeftAddon width={150}>Teléfono</InputLeftAddon>
                                <Input value={tempTelefono}m placeholder="Introduce el teléfono" onChange={(e)=>setTelefono(e.target.value)}></Input>                            
                                <BotonWhatsapp telefono={telefono} />
                            </InputGroup>                          

                            <InputGroup>
                                <InputLeftAddon width={150}>Correo Electrónico</InputLeftAddon>
                                <Input value={tempCorreoElectronico}m placeholder="Introduce el correo electrónico" onChange={(e)=>setCorreoElectronico(e.target.value)}></Input>                            
                            </InputGroup>

                            <InputGroup>
                                <InputLeftAddon width={150}>Referencia</InputLeftAddon>
                                <Input value={tempReferencia}m placeholder="Introduce la referencia" onChange={(e)=>setReferencia(e.target.value)}></Input>                            
                            </InputGroup>

                            <InputGroup>
                                <InputLeftAddon width={150}>Estado</InputLeftAddon>
                                <Select placeholder='Selecciona Opción' onChange={(e)=>setEstado(e.target.value)}
                                        defaultValue={tempEstado} >
                                            { dataestado?.map(c => (<option key={c.descripcion} value={c.descripcion}>{c.descripcion}</option>))}
                                </Select>
                            </InputGroup>

                            <InputGroup>
                                <InputLeftAddon width={150}>Pagado</InputLeftAddon>
                                    {/* <Checkbox isChecked={tempPagado} onChange={(e)=>setPagado2(e.target.checked)}>Pagado</Checkbox>                             */}
                                <BotonPagado valor={tempPagado} setPagado2={setPagado} />                            
                            </InputGroup>

                            <InputGroup>
                                <InputLeftAddon width={150}>Notas</InputLeftAddon>
                                <Textarea value={tempBody} placeholder='Introduce notas' onChange={(e)=>setBody(e.target.value)}></Textarea>
                            </InputGroup>                                                                                                        
                        </Stack>  


                        </ModalBody>

                        <ModalFooter>
                        <Button colorScheme="blue" mr={3} onClick={updateNote}>
                            Guardar
                        </Button>
                        <Button onClick={onClose}>Cerrar</Button>
                        </ModalFooter>
                    </ModalContent>
                    </Modal>
                </>
                {/* <Button bgColor={"#00e9bf"} onClick={()=>{ dispatch(deleteNotes(id)) }}>Eliminar</Button> */}
            </HStack>
        </CardFooter>
    </Card>
}

function BotonPagado (props) {
    const { valor , setPagado2} = props;
  
    return (
        
      <IconButton isRound={true} variant='solid' 
        // colorScheme='teal' 
        //onclick={(e)=>setPagado2(!valor)}
        onClick={() => { setPagado2(!valor) }}
        colorScheme={ valor ? 'teal' : 'red'}
        aria-label='Done' fontSize='20px' 
        icon={ valor ? <FaCheck /> : <FaTimes/>} />                                                                           
        
    );
  }
  
  function BotonWhatsapp (props) {
    const { telefono} = props;
  
    var link = "https://wa.me/34"+telefono;
    //console.log(" link => ",link);
    
    return (
      <>
      <a href={link} target="_blank">
  
      <Image src='/whatsapp.png' width={50} height={30} alt={link}
        // onclick={() => { console.log(" Telefono : ",link);}}    
        // onClick={() => { console.log(" Telefono : ",telefono);}}
          
            
          // }}
      />           
      </a>
      </>
    );
  }
  